module.exports = __webpack_public_path__ + "img/ccyd.b1b03bfd.png";